<template>
  <div
    class="tabbed-content-skeleton"
    role="status"
    aria-live="polite"
    aria-busy="true"
  >
    <!-- The placeholder blocks alone read as broken content, so lead with an
         explicit spinner + label that says the section is still working. -->
    <div class="flex flex-col items-center justify-center pt-12 gap-3">
      <AtomsLoadingSpinner />
      <p class="text-lg text-gray-500 font-ubuntu">{{ label }}</p>
    </div>

    <div v-if="layout === 'media'" class="max-w-3xl pt-8 pb-16 mx-auto">
      <div class="skeleton-block w-full h-72 sm:h-[420px]"></div>
      <div class="w-56 h-12 mx-auto mt-8 rounded skeleton-block"></div>
    </div>

    <div
      v-else
      class="flex flex-wrap items-start justify-center pt-8 pb-16 mx-auto gap-8 max-w-[1220px]"
    >
      <div v-for="card in 3" :key="card" class="w-full max-w-sm">
        <div class="w-2/3 h-8 mx-auto mb-3 rounded skeleton-block"></div>
        <div class="border border-neutral-400">
          <div class="w-full h-56 skeleton-block"></div>
          <div class="p-3 bg-[#f1f1f1]">
            <div class="w-3/4 h-5 mx-auto rounded skeleton-block"></div>
          </div>
          <div class="flex px-2 pt-3 pb-4 bg-white justify-evenly gap-4">
            <div
              v-for="detail in 4"
              :key="detail"
              class="w-12 rounded h-9 skeleton-block"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.tabbed-content-skeleton .skeleton-block {
  @apply bg-gray-200 animate-pulse;
}

/* AtomsLoadingSpinner is sized and coloured for the full-screen dark overlay,
   where white rings on a dimmed page are correct. Here it sits on the white
   panel, so recolour and scale it down for this context only. */
.tabbed-content-skeleton .loading-spinner {
  @apply w-14 h-14;
}

.tabbed-content-skeleton .loading-spinner div {
  @apply w-10 h-10 m-2 border-4;
  border-color: theme("colors.bc-dark-blue") transparent transparent transparent;
}
</style>

<script setup>
defineProps({
  // "cards" mirrors a product grid, "media" a single large image + button.
  layout: {
    type: String,
    default: "cards",
  },
  label: {
    type: String,
    default: "Loading…",
  },
});
</script>
